module.exports = __webpack_public_path__ + "static/media/oberflex-noyergrisflanelle-1200x2490.28c528ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-noyergrisflanelle-1200x2490.jpg
// module id = 1042
// module chunks = 37